module.exports = __webpack_public_path__ + "./img/paradigma-horizontal.530beda8ce3a47863a911c21a24f869b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Pages/Login/paradigma-horizontal.jpg
// module id = ./src/views/Pages/Login/paradigma-horizontal.jpg
// module chunks = 0